export const colors = ['#2caffe', '#00e272', '#fe6a35', '#6b8abc', '#d568fb', '#2ee0ca', '#fa4b42', '#feb56a', '#91e8e1'];

export const plotLines = {
  soiling_ratio: {
    label: 'Soiling Ratio',
    name: 'Soiling Ratio (incl. human cleaning)',
    color: 'rgb(84, 79, 197)',
  },
  soiling_mass_rate: {
    label: 'Soiling Mass Rate',
    name: 'Soiling Mass Rate',
    color: 'rgb(0, 226, 114)',
  },
  rain: {
    label: 'Precipitation [mm/day]',
    name: 'Precipitation [mm/day]',
    color: 'rgb(69, 200, 255)',
  },
  value: {
    label: 'Value',
    color: 'rgb(69, 200, 255)',
  },
  dc_no_soiling: {
    color: 'rgb(213, 104, 251)',
  },
  ac_soiling_clipping: {
    color: 'rgb(69, 200, 255)',
  },
  ac_soiling: {
    color: 'rgb(69, 200, 255)',
  },
  ac_no_soiling_clipping: {
    color: '#FF6B6B',
  },
  ac_no_soiling: {
    color: '#FF6B6B',
  },
  ac_soiling_no_clipping: {
    color: '#4ECDC4',
  },
  rain_threshold: {
    label: 'Rain Threshold',
    color: 'black',
  },
  market_price: {
    label: 'Market Price',
    color: 'red',
  },
  production: {
    label: 'Production with Soiling', // 'Production',
    color: 'green',
  },
  no_soiling_production: {
    label: 'Production without Soiling', // 'Reference Production',
    color: 'rgb(213, 104, 251)',
  },
  production_losses: {
    label: 'Production Losses',
    color: 'red',
  },
  production_losses_cost: {
    label: 'Production Losses Cost',
    color: 'red',
  },
  cleanings_cost: {
    label: 'Cleanings Cost',
    color: 'blue',
  },
  net_present_value: {
    label: 'Net Present Value',
    color: 'green',
  },
  cleaning: {
    label: 'Cleaning',
    color: 'rgba(255, 165, 0, 0.5)',
  },
};
